import { isBoolean } from 'src/utils/typeguards/isBoolean';
import { isNumber } from 'src/utils/typeguards/isNumber';
import { isString } from 'src/utils/typeguards/isString';
import { PrimitiveValue } from './types';

export const isPrimitive = (value: unknown): value is PrimitiveValue =>
    isNumber(value) || isString(value) || isBoolean(value);
